import { ExpenditureCategory, expenditureCategoryLabel } from '@signalvote/shared';

/**
 * The GeneralExpenditure category picker's options, ordered most-likely-first (a
 * real vendor payment leads; the long tail follows), minus the refund-reserved
 * ContributionRefund category. Kept as one source of truth so the classify picker
 * never re-derives the list.
 *
 * Labels are jurisdiction-aware: they delegate to the shared `expenditureCategoryLabel`,
 * which relabels Transfer / Reimbursement for Alabama (both file as ExPurpose "Other",
 * so the federal wording implies distinctions AL's portal doesn't have).
 */
const GENERAL_EXPENDITURE_CATEGORY_ORDER: readonly ExpenditureCategory[] = [
  ExpenditureCategory.Operating,
  ExpenditureCategory.Fundraising,
  ExpenditureCategory.Travel,
  ExpenditureCategory.Personnel,
  ExpenditureCategory.Advertising,
  ExpenditureCategory.Reimbursement,
  ExpenditureCategory.Transfer,
  ExpenditureCategory.Other,
];

export function generalExpenditureCategoryOptions(
  rulesetCode?: string | null,
): ReadonlyArray<{ value: ExpenditureCategory; label: string }> {
  return GENERAL_EXPENDITURE_CATEGORY_ORDER.map((value) => ({
    value,
    label: expenditureCategoryLabel(value, rulesetCode),
  }));
}
